import styled from 'styled-components';
import quotationMark from './images/quotation-mark.png';

const BlockQuoteContainer = styled.div`
  padding: 110px 70px 60px 70px;
  background: #fff;
  margin: 70px auto;
  position: relative;
  display: flex;
  border-top: 1px solid #d7dae3;
  border-bottom: 1px solid #d7dae3;

  &:before {
    content: url(${quotationMark});
    transform: scale(0.6);
    width: 24px;
    height: 18px;
    left: 64px;
    top: 60px;
    position: absolute;
  }

  .blog-block-quote--photo {
    width: 75px !important;
    height: 75px !important;
    min-width: 75px;
    border-radius: 50%;
    margin-right: 24px;
  }

  .blog-block-quote--author-sharing {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }

  .blog-block-quote--author {
    display: flex;
    align-items: center;

    p {
      margin: 0;
    }
  }

  .blog-block-quote--speaker-name {
    color: var(--neutral-6);
    font-size: 20px;
    font-weight: 700;
  }

  .blog-block-quote--speaker-title {
    font-size: 15px;
  }

  .blog-block-quote--author-info {
    height: max-content;
  }

  .blog-block-quote--quote {
    font-size: 31px;
    font-weight: bold;
    line-height: 130%;
    color: var(--blue-6);
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 75px 30px 25px 30px;

    &:before {
      top: 30px;
      left: 25px;
    }

    .blog-block-quote--photo {
      width: 50px !important;
      height: 50px !important;
      min-width: 50px;
    }

    .blog-block-quote--quote {
      font-size: 23px;
      line-height: 150%;
    }
  }

  @media (max-width: 576px) {
    .blog-block-quote--author-sharing {
      flex-direction: column;

      img {
        width: auto;
      }
    }

    .blog-block-quote--photo {
      margin: 0 0 15px 0;
      width: 75px !important;
      height: 75px !important;
      min-width: 75px;
    }

    .blog-block-quote--author-info {
      text-align: center;
    }

    .blog-block-quote--author {
      margin-bottom: 10px;
      flex-direction: column;
    }
  }
`;

export { BlockQuoteContainer };
